import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

export const uploadInvoiceFileApi = (file: File): Promise<ApiResponseType<{ file_key: string; file_name: string }>> => {
  const body = new FormData();

  body.append('file', file);

  return authApiService.UPLOAD_FILE('/invoice-vault/checks/upload/', body);
};
